import { render, staticRenderFns } from "./HospitalIntroDGKanghua.vue?vue&type=template&id=63c5f2ca&scoped=true"
import script from "./HospitalIntroDGKanghua.vue?vue&type=script&lang=js"
export * from "./HospitalIntroDGKanghua.vue?vue&type=script&lang=js"
import style0 from "./HospitalIntroDGKanghua.vue?vue&type=style&index=0&id=63c5f2ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c5f2ca",
  null
  
)

export default component.exports